import config from '../config';
import staticData from '../static_data/all';
import { getGoogleAnalyticsClientIds } from '../utils/tracking/googleAnalytics';
import { getFingerprint } from './browserFingerprinter';
import * as Sentry from '@sentry/browser';

export const CALL_API = process.env.REACT_APP_API_URL;

function callApi(endpoint, options) {
    const fullUrl =
        endpoint.indexOf(config.API_BASE_URL) === -1 && endpoint.indexOf('http') === -1
            ? config.API_BASE_URL + endpoint
            : endpoint;

    if (typeof fetch === 'undefined')
        return Promise.reject({ message: 'fetch is undefined' });

    return fetch(fullUrl, options).then(response =>
        response
            .text()
            .then(text => (text ? JSON.parse(text) : {}))
            .then(json => {

                if (!response.ok) {
                    const optionsLog = { ...options, body: JSON.parse(options.body) }

                    Sentry.withScope(function(scope) {
                      scope.setExtra("fullUrl", fullUrl);
                      scope.setExtra("options", JSON.stringify(optionsLog, null, 1));
                      scope.setExtra("response", JSON.stringify(response, null, 1));
                      scope.setExtra("json", JSON.stringify(json, null, 1));
                      Sentry.captureException(new Error('bad response: '+endpoint));
                    });

                    return Promise.reject(json);
                }
                return json;
            })

    ).catch(e=>{
        const optionsLog = { ...options, body: JSON.parse(options.body) }
        
        Sentry.withScope(function(scope) {
          scope.setExtra("error", JSON.stringify(e, null, 1));
          scope.setExtra("fullUrl", fullUrl);
          scope.setExtra("options", JSON.stringify(optionsLog, null, 1));
          Sentry.captureException(new Error('fetch request error: '+endpoint));
        });

        throw e;
    })
}

function callApiPost(endpoint, body) {
    return callApi(endpoint, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
}

function addGlobalParams(request) {
    const adCampaign = staticData.useStatic ? 'CAMPAIGN_ID' : null;
    return {
        adCampaign,
        ...getGoogleAnalyticsClientIds(),
        ...request
    };
}

function post(endpoint, request, options) {
    let body = addGlobalParams(request);

    if (options && options.useFingerprint) {
        return getFingerprint()
            .then(f => {
                return { fingerprint: f, ...body };
            })
            .then(b => {
                return callApiPost(endpoint, b);
            });
    }
    return callApiPost(endpoint, body);
}

function get(endpoint) {
    return callApi(endpoint, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    });
}

export default {
    get,
    post
};
